import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import ModeloPlantasInteractive from '../components/ModeloPlantasInteractive';
import ModeloTour3D from '../components/ModeloTour3D';
import HechoAMano, { fernandaCraftImages } from '../components/HechoAMano';
import FAQSection from '../components/FAQSection';
import { Link } from 'react-router-dom';
import { trackEvent as metaTrack } from '../lib/metaTrack';

const plantasData = [
  {
    label: 'Primer Nivel',
    image: '/images/fernanda-PB-p-800.webp',
    items: ['Entrada con privacidad', 'Sala', 'Comedor', 'Cocina abierta', 'Área de alacena', '1/2 baño', 'Jardín interior', 'Bodega', 'Estacionamiento para 2 autos'],
  },
  {
    label: 'Segundo Nivel',
    image: '/images/fernanda-PA-p-800.webp',
    items: ['Recámara principal con baño completo y vestidor', '2 recámaras secundarias', 'Baño completo compartido'],
  },
  {
    label: 'Terraza',
    image: '/images/fernanda-T-p-800.webp',
    items: ['Roof Garden', 'Espacio para asador', 'Área de lavado', 'Patio de tendido y servicio'],
  },
];

const galleryImages = [
  { bg: '/images/real/sm-fer-cocina-01-lg.webp', label: '' },
  { bg: '/images/real/sm-fer-interior-01-lg.webp', label: '' },
  { bg: '/images/real/sm-fer-cocina-03-lg.webp', label: '' },
  { bg: '/images/real/sm-fer-interior-04-lg.webp', label: '' },
  { bg: '/images/real/sm-fer-cocina-05-lg.webp', label: '' },
  { bg: '/images/real/sm-fer-interior-06-lg.webp', label: '' },
];

export default function ModeloFernanda() {
  useEffect(() => {
    metaTrack('ViewContent', {
      content_name: 'Modelo Fernanda',
      content_category: 'modelo',
      content_type: 'product',
    });
  }, []);

  return (
    <div className="page-wrapper">
      <Navbar />
      <Helmet>
        <html lang="es-MX" />
        <title>Modelo Fernanda · Casa de 3 a 4 recámaras · Santa Mónica Residencial Pachuca</title>
        <meta name="description" content="Modelo Fernanda: 3 a 4 recámaras, 2.5 baños, 143 m² de construcción sobre lote 127.5 m². Roof garden, cocina integral y acabados premium en Santa Mónica Residencial, Pachuca." />
        <meta name="keywords" content="modelo Fernanda, casa Pachuca 3 recámaras, casa con roof garden Hidalgo, Santa Mónica Residencial, casa con cochera Pachuca, INFONAVIT Pachuca" />
        <link rel="canonical" href="https://santamonicaresidencial.mx/modelo-fernanda" />
        <meta property="og:type" content="product" />
        <meta property="og:title" content="Modelo Fernanda · Santa Mónica Residencial" />
        <meta property="og:description" content="3 a 4 recámaras, 2.5 baños, 143 m² · Roof garden privado · Pachuca, Hidalgo." />
        <meta property="og:image" content="https://santamonicaresidencial.mx/images/real/sm-fer-hero-card-lg.webp" />
        <meta property="og:url" content="https://santamonicaresidencial.mx/modelo-fernanda" />
        <meta name="twitter:title" content="Modelo Fernanda · Santa Mónica Residencial" />
        <meta name="twitter:description" content="3 a 4 recámaras, 2.5 baños, 143 m² · Roof garden privado · Pachuca, Hidalgo." />
        <meta name="twitter:image" content="https://santamonicaresidencial.mx/images/real/sm-fer-hero-card-lg.webp" />
        <script type="application/ld+json">{`{
          "@context": "https://schema.org",
          "@type": "Product",
          "name": "Casa Modelo Fernanda · Santa Mónica Residencial",
          "image": "https://santamonicaresidencial.mx/images/real/sm-fer-hero-card-lg.webp",
          "description": "Casa residencial de 3 a 4 recámaras, 2.5 baños, 143 m² de construcción sobre lote tipo de 127.5 m². Roof garden, cocina integral y acabados premium en Pachuca, Hidalgo.",
          "brand": {"@type":"Brand","name":"Santa Mónica Residencial"},
          "category": "Casas residenciales en Pachuca",
          "url": "https://santamonicaresidencial.mx/modelo-fernanda"
        }`}</script>
      </Helmet>
      <main className="main-wrapper">
        {/* HERO MODELO — premium twilight backdrop */}
        <section className="hero-modelo-v2" data-testid="hero-modelo-fernanda">
          <div
            className="hero-modelo-v2__bg"
            style={{ backgroundImage: "url('/images/real/sm-fer-hero-card-lg.webp')" }}
          />
          <div className="hero-modelo-v2__overlay" />
          <div className="page-padding hero-modelo-v2__content">
            <div className="container-large">
              <div className="hero-modelo-v2__inner">
                <div className="hero-modelo-v2__text">
                  <div className="text-label hero-modelo-v2__eyebrow">casas residenciales en pachuca</div>
                  <h1 className="sm-h1 hero-modelo-v2__title">
                    Modelo <span className="serif-accent">Fernanda</span>
                  </h1>
                  <p className="hero-modelo-v2__lead">
                    Amplios espacios funcionales que promueven el bienestar y una convivencia
                    saludable. <strong>143 m²</strong> de construcción sobre lote tipo de <strong>127.5 m²</strong>.
                  </p>
                  <div className="hero-modelo-v2__meta">
                    <span><span className="icon-font">bed</span>3 a 4 recámaras</span>
                    <span><span className="icon-font">shower</span>2.5 baños</span>
                    <span><span className="icon-font">directions_car</span>2 autos</span>
                    <span><span className="icon-font">stairs</span>3 niveles</span>
                  </div>
                  <a
                    href="#proyecto"
                    className="btn cta-special contrast-variant big hero-modelo-v2__cta"
                    onClick={(e) => { e.preventDefault(); document.querySelector('#proyecto')?.scrollIntoView({ behavior: 'smooth' }); }}
                    data-testid="hero-modelo-cta"
                  >
                    <div className="btn-cta-bg" />
                    <div className="icon-btn-container">
                      <div className="icon-btn-text">Ver distribución y planos</div>
                      <div className="icon-btn-icon"><span className="icon-font">south</span></div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* DISTRIBUCIÓN — Plantas interactivas + specs strip */}
        <ModeloPlantasInteractive
          modelName="Fernanda"
          construccion="143 m²"
          lote="127.5 m²"
          recamaras="3 a 4"
          banos="2.5"
          cochera="2 autos"
          levels={plantasData}
          accent="#f6802c"
        />

        {/* RECORRIDO VIRTUAL — inline cinematográfico */}
        <ModeloTour3D
          modelName="Fernanda"
          matterport="https://my.matterport.com/show/?m=tBsE9SN6rZz&play=1&qs=1&hr=0&brand=0"
          poster="/images/real/sm-fer-twilight-01-lg.webp"
          accent="#f6802c"
          specs={[
            { icon: 'bed', label: '3 a 4 recámaras', sub: '1 en planta baja' },
            { icon: 'shower', label: '2.5 baños', sub: 'completos + medio' },
            { icon: 'directions_car', label: '2 autos', sub: 'cochera techada' },
            { icon: 'square_foot', label: '143 m²', sub: 'construcción' },
            { icon: 'crop_landscape', label: '127.5 m²', sub: 'lote tipo' },
            { icon: 'stairs', label: '3 niveles', sub: 'incluye roof' },
          ]}
        />

        {/* CROSS-LINK to Modelo Mariana */}
        <section className="modelo-crosslink" data-testid="crosslink-mariana">
          <div className="modelo-crosslink-content">
            <div className="text-label" style={{ color: 'rgba(255,255,255,0.7)' }}>modelo mariana</div>
            <h3 className="sm-h2" style={{ color: '#fff' }}>
              ¿Necesitas <span className="serif-accent" style={{ color: 'var(--brand-accent)' }}>más espacio</span> para tu familia?
            </h3>
            <p style={{ color: 'rgba(247,252,255,0.85)', maxWidth: '50ch' }}>
              Conoce el modelo Mariana: 163 m² de construcción, mayor área social y roof garden privado.
            </p>
            <Link to="/modelo-mariana" className="btn cta-special contrast-variant big" style={{ display: 'inline-flex', marginTop: '1rem' }}>
              <div className="btn-cta-bg" />
              <div className="icon-btn-container">
                <div className="icon-btn-text">Ver modelo Mariana</div>
                <div className="icon-btn-icon"><span className="icon-font">east</span></div>
              </div>
            </Link>
          </div>
          <div className="modelo-crosslink-image cta-mariana" />
        </section>

        {/* HECHO A MANO */}
        <HechoAMano images={fernandaCraftImages} />

        {/* FAQ */}
        <FAQSection />

        {/* CREDITOS */}
        <section className="creditos">
          <div className="page-padding">
            <div className="container-medium">
              <div className="padding-vertical padding-medium">
                <div className="_2-grid-col v-align-center">
                  <div className="element-content">
                    <div className="text-content">
                      <div className="text-label" style={{ color: 'rgba(255,255,255,0.7)' }}>créditos hipotecarios</div>
                      <h2 className="sm-h2">Pregunta por tu crédito inmobiliario</h2>
                      <p>Te ayudamos a calificar con cualquier banco o instituto público. Tu asesor compara opciones y elige la mejor tasa para tu perfil.</p>
                    </div>
                  </div>
                  <div className="element-content">
                    <img loading="lazy" src="/images/logos-creditos-1.png" alt="Créditos" style={{ width: '100%' }} />
                    <img loading="lazy" src="/images/logos-creditos-2.png" alt="Créditos" style={{ width: '100%' }} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
